<template>
<div class="chapter">
<div class="inner_page">
<p class="left"><a id="piv"></a> Copyright © 2009 by Debra Gwartney</p>
<p class="timebreak"> <br/></p>
<p class="left">All rights reserved</p>
<p class="timebreak"> <br/></p>
<p class="left">For information about permission to reproduce selections from this book, write to Permissions, Houghton Mifflin Harcourt Publishing Company, 215 Park Avenue South, New York, New York 10003.</p>
<p class="timebreak"> <br/></p>
<p class="left"><a href="http://www.hmhco.com/popular-reading" target="_blank">www.hmhco.com</a></p>
<p class="timebreak"> <br/></p>
<p class="left"><em>The Library of Congress has cataloged the print edition as follows:</em><br/>
Gwartney, Debra.</p>
<p class="left">Live through this: a mother’s memoir of runaway daughters / Debra Gwartney.<br/>
p. cm.</p>
<p class="left"><span style="font-size: smaller">ISBN</span> 978-0-547-05447-6</p>
<p class="left">1. Runaway teenagers—West (U.S.) 2. Teenage girls—West (U.S.) 3. Mothers and daughters—West (U.S.) I. Title.<br/>
<span style="font-size: smaller">HV</span>1435.W4G93 2008<br/>
362.74—dc22<br/>
[<span style="font-size: smaller">B</span>] 2008013751</p>
<p class="timebreak"> <br/></p>
<p class="left">e<span style="font-size: smaller">ISBN</span> 978-0-547-34788-2<br/>
v2.0414</p>
<p class="timebreak"> <br/></p>
<p class="left"><em>Note:</em> Some names have been changed to protect the privacy of individuals.</p>
<p class="timebreak"> <br/></p>
<p class="left">Excerpt from “Birches” from <em>The Poetry of Robert Frost</em> edited by Edward Connery Lathem. Copyright 1916, 1969 by Henry Holt and Company. Copyright 1944 by Robert Frost. Reprinted by permission of Henry Holt and Company, LLC.</p>
<p class="timebreak"> <br/></p>
<p class="left">Portions of this book previously appeared in a somewhat different form: “Far Away, So Close,” in <em>Salon,</em> “Mothers Who Think” column, November 23, 1998; “Tenderloin,” in <em>Creative Nonfiction,</em> no. 16, 1999, pages 21–30; “Tent,” in <em>Fourth Genre,</em> vol. 3, no. 1, Spring 2001, pages 20–27; “Out of Gas,” in <em>Tampa Review,</em> 33/34, 2007, pages 19–27; “Runaway Bus,” in <em>Portland Monthly,</em> January 2006. “Runaway Daughter” was included in the anthology <em>I Wanna Be Sedated,</em> published by Seal Press, March 2005. And a segment related to this book was broadcast on <em>This American Life,</em> Chicago Public Radio, March 29, 2002.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front01.vue?1a10aa84